module.exports = __webpack_public_path__ + "img/shirp.55210364.png";